import React, { useContext } from "react";

import Layout from "./shared/Layout";
import ServiceItem from "../components/shift-personel-service/ShiftPersonelServiceItem";
import NewServiceItem from "../components/shift-personel-service/NewShiftPersonelServiceItem";
import { StoreContext } from "shared/context/store-context";
import { vehicleroutetypes } from "shared/util/types";

const StandardPersonelServices = () => {
  const { shiftPersonelServices, schoolOptions, driverOptions } = useContext(StoreContext);
  const itemType = "shiftpersonelservice";
  const listName = "shiftpersonelservices";

  const listColumns = [
    {
      field: "school",
      headerName: "Kurum",
      width: 200,
      valueGetter: (params) =>
        schoolOptions.find((item) => item?.value?.toString() == params.row.school.toString())?.label,
    },
    { field: "name", headerName: "İsim", width: 400 },
    {
      field: "type",
      headerName: "Türü",
      width: 100,
      valueGetter: (params) =>
        vehicleroutetypes.find((item) => item?.value?.toString() == params.row.type.toString())?.label,
    },
    {
      field: "drivers",
      headerName: "Ana Sürücü",
      width: 300,
      valueGetter: (params) => {
        try {
          return driverOptions.find((item) => item.value.toString() === params?.row?.drivers[0]?.toString()).label;
        } catch (e) {
          return "";
        }
      },
    },
    { field: "plate", headerName: "Plaka", width: 100 },
  ];

  return (
    <Layout
      itemType={itemType}
      items={shiftPersonelServices}
      listName={listName}
      listColumns={listColumns}
      SelectedItemComponent={ServiceItem}
      NewItemComponent={NewServiceItem}
    />
  );
};

export default StandardPersonelServices;
